var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34375 3.28125C6.34375 2.91758 6.63633 2.625 7 2.625C7.36367 2.625 7.65625 2.91758 7.65625 3.28125V6.65L9.98867 8.20312C10.2895 8.40547 10.3715 8.81289 10.1473 9.11367C9.96953 9.41445 9.56211 9.49648 9.26133 9.27227L6.63633 7.52227C6.45312 7.42383 6.34375 7.21875 6.34375 6.97539V3.28125ZM7 0C10.8664 0 14 3.13359 14 7C14 10.8664 10.8664 14 7 14C3.13359 14 0 10.8664 0 7C0 3.13359 3.13359 0 7 0ZM1.3125 7C1.3125 10.1418 3.8582 12.6875 7 12.6875C10.1418 12.6875 12.6875 10.1418 12.6875 7C12.6875 3.8582 10.1418 1.3125 7 1.3125C3.8582 1.3125 1.3125 3.8582 1.3125 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteDate);
export default __webpack_public_path__ + "static/media/vote-date.82310963a1da14c5c245c21817e5665d.svg";
export { ForwardRef as ReactComponent };